import { As } from "@chakra-ui/react";
import { PEOPLE_TEAM_ROUTES, SHARED_ROUTES } from "definitions/constants/routeConstants";
import { GoChecklist } from "react-icons/go";
import { BiGitMerge } from "react-icons/bi";
import { FiHome, FiStar } from "react-icons/fi";
import { IoPeopleOutline } from "react-icons/io5";

export const baseDashboard = {
  id: "home",
  name: "Home",
  route: SHARED_ROUTES.home,
  icon: FiHome,
  routeMatchExact: true,
};

export const baseTasks = {
  id: "tasks",
  name: "My Tasks",
  route: SHARED_ROUTES.myTasks,
  icon: GoChecklist,
};

export const baseMyJourneys = {
  id: "my-journeys",
  name: "Supported Journeys",
  route: SHARED_ROUTES.myJourneys,
  icon: IoPeopleOutline,
};

export const baseMyOnboarding = {
  id: "my-onboarding",
  name: "My Onboarding",
  route: SHARED_ROUTES.newHirePortal,
  icon: FiStar,
};

export const companyIntegrations = {
  id: "integrations",
  name: "Integrations",
  route: PEOPLE_TEAM_ROUTES.company.integrations.index,
  icon: BiGitMerge,
};

export interface SidebarSection {
  id: string;
  header?: string;
  items: SideBarItem[];
}

export interface SubItem {
  name: string;
  route: string;
  icon?: As;
}

export interface RouteConfig {
  path: string;
  exactMatch?: boolean;
}

export interface SideBarItem {
  id: string;
  name: string;
  route: string;
  icon: As;
  subItems?: SubItem[];
  routeMatchExact?: boolean;
  additionalRoutes?: RouteConfig[];
  /**
   * If set, the item is only rendered when the named feature flag is enabled
   * for the current user. See `useFeatureContext`.
   */
  featureFlag?: string;
}
